import AdditionalCheckFieldControl from 'purchase/checkout/AdditionalCheckFieldControl';

const { FormControl } = window.od;

class LinkAccountFormControl extends FormControl {
	initFieldControl(field) {
		if (field.name === 'phoneNumber') {
			const rules = this.rules[field.name];
			return new AdditionalCheckFieldControl(field, rules, this.fields);
		}
		return super.initFieldControl(field);
	}
}

export default LinkAccountFormControl;
